import React from "react"

import useExitAnimationFade from "../../animations/useExitAnimationFade"
import useParallaxItems from "../../animations/useParallaxItems"
import SEO from "../../components/seo"
import SectionAbout from "./SectionAbout"
import SectionContact from "./SectionContact"
import SectionHero from "./SectionHero"
import SectionProjects from "./SectionProjects"

import "./index.scss"

const IndexPage = ({ data: pageData }) => {
  useParallaxItems()
  useExitAnimationFade()

  console.log(pageData)

  return (
    <div
      className="page home"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        textAlign: "center",
        padding: "2rem",
      }}
    >
      <SEO
        title="We'll be back soon!"
        description="At Stella Renovations we specialise in transforming and revitalising old existing spaces into beautiful high functioning homes with strength and personality. We are based in Christchurch, New Zealand."
      />
      <h1 style={{ fontSize: "3rem", marginBottom: "1rem" }}>
        Temporarily Down for Maintenance
      </h1>
      <p style={{ fontSize: "1.5rem" }}>
        We are currently updating our site. Please check back soon!
      </p>
    </div>
  )
}
export default IndexPage
